import { PropTypes } from 'react-desc';
export var ROUTER_PROPS = {
  path: PropTypes.string.description('Indicates the path to be used for react-router link.').isRequired,
  method: PropTypes.oneOf(['push', 'replace']).description('Indicates whether the browser history should be appended to or replaced.').defaultValue('push')
};


//////////////////
// WEBPACK FOOTER
// /Users/dnlytras/.npm/_npx/11246/lib/node_modules/landr/theme/node_modules/grommet/es6/utils/router.js
// module id = 463
// module chunks = 2